import * as React from 'react'
import {IconProps} from 'types/IconProps'

// TODO (Search) [2022-03-16] dq82hd-desktop-map
// If A-side wins remove this component from Atlas
const PersonBorder = ({color = 'currentColor', size = 20}: IconProps) => (
  <svg
    width={size}
    height={size}
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 0C4.58 0 0 4.58 0 10s4.58 10 10 10 10-4.58 10-10S15.42 0 10 0Zm0 5c1.73 0 3 1.27 3 3s-1.27 3-3 3-3-1.27-3-3 1.27-3 3-3Zm-1 7.57c-1.71 0-3.2.88-4.1 2.2a6.97 6.97 0 0 0 10.2 0 4.96 4.96 0 0 0-4.1-2.2H9Z"
    />
  </svg>
)

export default PersonBorder
